export default "__VITE_ASSET__UONm0PkL__"